import React from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import BarraNavegacion from './components/BarraNavegacion';
import Hero from './pages/Hero';
import QueHacemos from './pages/QueHacemos';
import NuestroCompromiso from './pages/NuestroCompromiso';
import NewsLetter from './pages/NewsLetter';
import NuestrosClientes from './pages/NuestrosClientes';
import News from './pages/News';
import Footer from './components/Footer';
import Contacto from './pages/Contacto';

import Privacidad from './pages/Privacidad';
import Terminos from './pages/Terminos';
import Unsubscribe from './pages/Unsubscribe';

import 'bootstrap/dist/css/bootstrap.min.css';
import '@fortawesome/fontawesome-free/css/all.min.css';
import './App.css';

function App() {

  return (
    <Router>
      <div className="App">
        <BarraNavegacion />
        <Routes>
          <Route path='/' element={
            <>
              <Hero />
              <QueHacemos />
              <NuestroCompromiso />
              <NuestrosClientes />
              <Contacto />
              <News />
              <NewsLetter />
            </> } />
            <Route path="/privacidad" element={ <Privacidad />} />
            <Route path="/terminos" element={ <Terminos /> } />
            <Route path="/unsubscribe/:email" element={ <Unsubscribe/> } />
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
